import { initializeConnector } from "@web3-react/core";
import { WalletConnect as WalletConnectV2 } from "@web3-react/walletconnect-v2";

const metadata = {
  name: "Gems Landing",
  description: "Gems Landing DApp",
  url: window.location.origin,
  icons: [`${window.location.origin}/favicon.ico`],
};

export const [walletConnectV2, hooks] = initializeConnector((actions) => {
  return new WalletConnectV2({
    actions,
    options: {
      projectId: "204ef6df53447b48a9ee176786b9eff5",
      chains: [1],
      optionalChains: [8453, 56, 42161],
      metadata,
      showQrModal: true,
    },
    timeout: 5000,
    onError: (err) => {
      console.log("error in connector:", err);
    },
  });
});

export const switchChain_trust = async (connector, chainId) => {
  if (connector instanceof WalletConnectV2) {
    try {
      await connector.activate(chainId);
      console.log(`Switched to chainId: ${chainId}`);
    } catch (error) {
      console.error("Failed to switch chain:", error);
    }
  } else {
    console.error("Connector is not an instance of WalletConnectV2");
  }
};
